/******************************************************************************************
 *	Organization Details Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.orgainzationDetails', []).controller(
    'OrganizationDetailsController',
    /* @ngInject */
    function($scope, User) {
      $scope.reseller = User.getReseller();
    }
  );
})();
